<template>
  <vs-popup class="croper-popup" :active.sync="cropper.show" :buttons-hidden="true" @close="cancelCropper">
    <div class="main-title ml-1">
      <h4>{{ $t('Crop Image') }}</h4>
    </div>

    <div class="relative mt-8">
      <cropper
        ref="cropper"
        class="cropper"
        :src="cropper.initialImg"
        :default-size="cropper.defaultSize"
        :resizeImage="false"
        :stencil-props="{
          movable: true,
          resizable: false,
          aspectRatio: 16 / 9,
          handlers: {
            eastNorth: false,
            north: false,
            westNorth: false,
            west: false,
            westSouth: false,
            south: false,
            eastSouth: false,
            east: false
          }
        }"

        @change="onChange"
      >
      </cropper>
    </div>

    <section class="text-right space-x-3 croper-actions actions mt-8">
      <button
        class="croper-cancel-action action-cancel"
        @click="cancelCropper"
      >
        {{ $t('Cancel') }}
      </button>

      <button
        class="croper-apply-action action-submit"
        type="filled"
        @click="applyCropper"
      >
        {{ $t('Apply') }}
      </button>
    </section>
  </vs-popup>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  props: {
    cropper: {
      type: Object,
      required: true,
      default () {
        return {
          show: false,
          initialImg: '',
          resultBase64: '',
          coordinates: {},
          defaultSize: {
            width: 640,
            height: 360
          }
        }
      }
    }
  },

  components: {
    Cropper
  },

  data () {
    return {
      coordinates: {},
      resultBase64: null
    }
  },

  mounted () {
    if (this.cropper.coordinates) {
      this.$refs.cropper.setCoordinates(this.cropper.coordinates)
    }
  },

  methods: {
    cancelCropper ()  {
      this.$emit('cancel-cropper', this.cropper)
    },

    applyCropper ()  {
      this.cropper.coordinates = this.coordinates
      this.cropper.resultBase64 = this.resultBase64

      this.$emit('apply-cropper', this.cropper)
    },

    onChange ({ coordinates, canvas }) {
      this.coordinates = coordinates
      this.resultBase64 = canvas.toDataURL()
    }
  }
}
</script>

<style lang="scss" scoped>

.croper-popup {
  z-index: 9999999999;
}

.cropper {
  height: 382px;
  width: 100%;
  background: #ddd;
}

.croper-popup /deep/ .vs-popup {
  width: 676px !important;
}

@media (max-width: 576px) {
  .croper-actions {
    display: flex;
    flex-direction: column-reverse;

    margin-right: 0 !important;
    .croper-cancel-action,
    .croper-apply-action {
      width: 100%;
    }

    .croper-apply-action {
      margin-left: 0 !important;
      margin-bottom: 12px;
    }
  }
}
</style>
